function toggleDropdown() {
  const dropdown = document.getElementById("dropdownContent");
  const button = document.getElementById("dropdownButton");

  dropdown.classList.toggle("show");
  button.classList.toggle("open");
}

window.onclick = function (event) {
  if (!event.target.closest(".dropdown")) {
    const dropdowns = document.getElementsByClassName("dropdown-content");
    const buttons = document.getElementsByClassName("dropbtn");
    for (let i = 0; i < dropdowns.length; i++) {
      dropdowns[i].classList.remove("show");
      buttons[i].classList.remove("open");
    }
  }
};
